export const NetQuestFavIcons = [
  {
    rel: 'shortcut icon',
    href: '/Fav-Icon-Flash-Survey.png?v=3'
  }
];